module.exports = __webpack_public_path__ + "static/media/payment-failure.2300b5d1.svg";